<template>
  <div>
    <template v-if="disabled">
      <span class="text-primary">{{ data }}</span>
    </template>
    <b-form-input
      v-else
      v-model="data"
      :placeholder="option.placeholder? option.placeholder : $t('_components.placeholder.input')+label"
      type="number"
      class="d-inline-block"
      :max="option.numberMax"
      :min="option.numberMin"
      :oninput="option.maxLength ? `if(value.length>${option.maxLength})value=value.slice(0,${option.maxLength})` : ''"
    />
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  computed: {

  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        if (this.option.numberMin || this.option.numberMin === 0) {
          if (/^-[1-9]+/.test(e)) {
            setTimeout(() => {
              if (e < this.option.numberMin) {
                this.data = this.option.numberMin
              }
            }, 10);
          }
        }

        if (e > this.option.numberMax && (this.option.numberMax || this.option.numberMax === 0)) {
          setTimeout(() => {
            this.data = this.option.numberMax
          }, 10);
        }
        if (e < this.option.numberMin && (this.option.numberMin || this.option.numberMin === 0)) {
          setTimeout(() => {
            this.data = this.option.numberMin
          }, 10);
        }
        if (this.option.numberMin || this.option.numberMin === 0) {
          if (/^0[0-9]+/.test(e)) {
            setTimeout(() => {
              if (this.option.numberMin === 0) {
                this.data = this.option.numberMin
                const num = parseInt(e, 10)
                this.data = num
              }
              if (this.option.numberMin !== 0) {
                const num = parseInt(e, 10)
                if (num <= this.option.numberMin) {
                  this.data = this.option.numberMin
                }
              }
            }, 10);
          }
        }

        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
